import { RequestMethod } from '~packages/json-api/client';
import replacePlaceholdersCustom, {
  PathParts,
} from '~packages/json-api/client/helpers/__base/replacePlaceholdersCustom';

import EpkModuleApiService from './EpkModuleApiService';

export interface IDeleteCrudParts {
  code: number;
}

export default class EpkEntityModuleApiService extends EpkModuleApiService {
  constructor(params = {}) {
    super(params);
  }

  async deleteCrud(parts: IDeleteCrudParts) {
    return await this._sendRequest(
      replacePlaceholdersCustom('/crud/{code}', parts as unknown as PathParts),
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'deleteCrud' }
    );
  }
}
